import { Injectable, inject } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { MetaTagConfig } from "../types/meta-tag.interface";

@Injectable({
  providedIn: "root",
})
export class MetaTagService {
  private meta = inject(Meta);
  private title = inject(Title);

  private readonly defaultConfig: MetaTagConfig = {
    title: "Lawyerty",
    description:
      "Lawyerty - Professional legal services platform providing comprehensive legal solutions and expert consultation for individuals and businesses.",
    keywords:
      "legal services, lawyer, consultation, legal advice, professional legal help",
    author: "Lawyerty Team",
    robots: "noindex, nofollow",
    ogTitle: "Lawyerty - Professional Legal Services",
    ogDescription:
      "Professional legal services platform providing comprehensive legal solutions and expert consultation for individuals and businesses.",
    twitterCard: "summary_large_image",
  };

  updateMetaTags(config: MetaTagConfig): void {
    const merged: MetaTagConfig = { ...this.defaultConfig, ...config };

    this.title.setTitle(merged.title ?? "Lawyerty");

    this.meta.updateTag({
      name: "description",
      content: merged.description ?? "",
    });
    this.meta.updateTag({ name: "keywords", content: merged.keywords ?? "" });
    this.meta.updateTag({ name: "author", content: merged.author ?? "" });
    this.meta.updateTag({ name: "robots", content: merged.robots ?? "" });

    // Open Graph tags
    this.meta.updateTag({
      property: "og:title",
      content: merged.ogTitle ?? "",
    });
    this.meta.updateTag({
      property: "og:description",
      content: merged.ogDescription ?? "",
    });
    if (merged.ogImage) {
      this.meta.updateTag({ property: "og:image", content: merged.ogImage });
    } else {
      this.meta.removeTag('property="og:image"');
    }
    if (merged.ogUrl) {
      this.meta.updateTag({ property: "og:url", content: merged.ogUrl });
    } else {
      this.meta.removeTag('property="og:url"');
    }

    // Twitter Card tags
    this.meta.updateTag({
      name: "twitter:card",
      content: merged.twitterCard ?? "",
    });
    this.meta.updateTag({
      name: "twitter:title",
      content: merged.twitterTitle ?? merged.title ?? "Lawyerty",
    });
    this.meta.updateTag({
      name: "twitter:description",
      content: merged.twitterDescription ?? merged.description ?? "",
    });
    if (merged.twitterImage) {
      this.meta.updateTag({
        name: "twitter:image",
        content: merged.twitterImage,
      });
    } else {
      this.meta.removeTag('name="twitter:image"');
    }
  }

  setDefaultMetaTags(): void {
    this.updateMetaTags({});
  }
}
